
import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'

import RequireLogin from './RequireLogin';

import JournalView from './JournalView';
import LoginView from './LoginView';

import firebase from 'firebase';

import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
// import blue from 'material-ui/colors/blue';
// import deepPurple from 'material-ui/colors/deepPurple';
// import red from 'material-ui/colors/red';


const theme = createMuiTheme({
  // palette: {
  //   primary: blue, // Purple and green play nicely together.
  //   secondary: deepPurple,
  //   error: red,
  // },
});

// console.log(theme);

class AppGlobal extends Component {
  state = {
    loaded: false,
  }

  componentWillMount() {
    this.deregisterFirebaseAuthListener = firebase.auth().onAuthStateChanged(this.setup.bind(this));
  }

  componentWillUnmount() {
    this.deregisterFirebaseAuthListener && this.deregisterFirebaseAuthListener();
  }

  setup(user) {
    this.setState({loaded: true});
  }

  render() {
    if (this.state.loaded) {
      return this.props.children;
    } else {
      return (
        <div></div>
      )
    }
  }
}

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <AppGlobal>
          <Router>
            <Switch>
              <RequireLogin exact path="/" component={JournalView}/>
              <Route path="/login" component={LoginView}/>
            </Switch>
          </Router>
        </AppGlobal>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js